/* eslint-disable */
import VueI18n from 'vue-i18n';
import cookies from '@utils/cookies';

const COOKIE_APP_LANGUAGE = 'amc_lang';

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
});

export const getLocale = () => {
  let locale = cookies.getItem(COOKIE_APP_LANGUAGE);
  if (!locale) {
    locale = window.navigator.language;
  }

  return {
    lang: _.head(locale.split('_')),
    locale,
  };
};
